import { client } from "@/http/client"

import { IResponse } from "@/types/api"
import { IMenuLinks } from "@/types/IMenuLinks"


export const getMenuLinks = (): Promise<IResponse<IMenuLinks>> =>
  client.get("MenuLinks")

export const updateMenuLinks = (body: IMenuLinks): Promise<IResponse<number>> =>
  client.put("MenuLinks", body)